module.exports = __webpack_public_path__ + "img/create_database.9588c1bf.png";